import { TCoverageSideEffectsType } from '@sureapp/platform-sdk';

import { TConfig, TConfigInput } from '@@/auto/interfaces';

import { AUTO_DISCOUNTS } from '../../autoDiscounts';

function ToggleTXConfig(): DeepPartial<TConfigInput> {
  return {
    autoDiscounts: [
      AUTO_DISCOUNTS.antiTheft,
      AUTO_DISCOUNTS.safeDriving,
      AUTO_DISCOUNTS.multiCar,
      AUTO_DISCOUNTS.multiPolicy,
      AUTO_DISCOUNTS.homeowner,
      AUTO_DISCOUNTS.goodStudent,
      AUTO_DISCOUNTS.distantStudent,
      AUTO_DISCOUNTS.teenDriver,
    ],
    auto: (auto: TConfig['auto']) => ({
      ...auto,
      addOns: {
        ...auto.addOns,
        options: {
          ...auto.addOns.options,
          oem_parts: {
            ...auto.addOns.options.oem_parts,
            copy: {
              ...auto.addOns.options.oem_parts?.copy,
              modalContent: `This is an optional coverage that pays for original factory equipment replacement parts in the event that your vehicle is damaged in a covered loss. Non original factory equipment replacement parts shall not be used on current year or immediate prior year model cars without your permission.`,
            },
          },
        },
      },
    }),
    coverage: (coverage: TConfig['coverage']) => ({
      ...coverage,
      personalInjuryProtection: {
        ...coverage.personalInjuryProtection,
        title: 'Personal Injury Protection',
        description:
          'Accidents can be scary, especially when you or someone you love is injured. If that happens, though, this coverage can help lessen the impact to your wallet (or theirs).',
        modalContent:
          'Personal Injury Protection (PIP) coverage could pay for reasonable medical expenses, funeral expenses, lost income, and essential services incurred by an insured person on your policy caused by an accident, up to the limit selected and regardless of fault.',
        textAlertContent: '',
      },
      uninsuredMotoristPropertyDamage: {
        ...coverage.uninsuredMotoristPropertyDamage,
        description: `Your bumper sticker might say 'don't hit me if you're uninsured or underinsured' but it isn't actually protecting you against that. Don't worry, this coverage can.`,
        modalContent: `Uninsured Motorist Property Damage (UMPD) pays, up to the limits chosen, the amount you are legally entitled to recover for physical damages to your insured car sustained in an accident caused by a driver who is not insured or doesn't have enough insurance to cover the damage. Note: Payments for this coverage are subject to a $250 deductible.`,
      },
      uninsuredMotoristBodilyInjury: {
        ...coverage.uninsuredMotoristBodilyInjury,
        description: `That pain in your neck is not just from the accident - it's also from finding out that the person who hit you has either no insurance or not enough. This coverage can help.`,
        modalContent: `Uninsured Motorist Bodily Injury (UMBI) pays the amount you are legally entitled to recover for damages from bodily injury, up to the limit of liability, when an insured person on your policy is hit by an uninsured driver, underinsured driver, or an unidentified (e.g. hit-and-run) driver.`,
      },
    }),
    coverageTextAlerts: (
      coverageTextAlerts: TConfig['coverageTextAlerts']
    ) => ({
      ...coverageTextAlerts,
      UMBI_UPDATE: ({ isRemoved, causeName }: TCoverageSideEffectsType) =>
        isRemoved
          ? ''
          : `Your Uninsured Motorist Bodily Injury limits may have changed based on the changes you've made to your ${causeName} coverage.`,
      UIMBI_UPDATE: ({ isRemoved, causeName }: TCoverageSideEffectsType) =>
        isRemoved
          ? ''
          : `Your Underinsured Motorist Bodily Injury limits may have changed based on the changes you've made to your ${causeName} coverage.`,
    }),
    initialCoverageValues: (
      initialCoverageValues: TConfig['initialCoverageValues']
    ) => ({
      ...initialCoverageValues,
      gap: 'false',
      temporary_ride: 'null',
      side_hustle: 'false',
    }),
    visibleCoverages: (visibleCoverages: TConfig['visibleCoverages']) => {
      return {
        ...visibleCoverages,
        protectionCoverages: [
          ...visibleCoverages.protectionCoverages.filter(
            ({ key }) =>
              ![
                'medical_limit',
                'pet_passenger',
                'uninsured_motorist_property_damage_limit',
                'personal_injury_protection_limit',
              ].includes(key)
          ),
          {
            label: 'Uninsured Motorist Property Damage',
            key: 'uninsured_motorist_property_damage_limit',
          },
          {
            label: 'Personal Injury Protection',
            key: 'personal_injury_protection_limit',
          },
          visibleCoverages.protectionCoverages.find(
            ({ key }) => key === 'pet_passenger'
          ),
        ],
      };
    },
  };
}

export default ToggleTXConfig;
